export function extractDigits(input: string): string;
export function extractDigits(input: null | undefined): null;
export function extractDigits(input: null | undefined | string): null | string;
export function extractDigits(input: null | undefined | string): null | string {
  return input?.replace(NON_DIGITS_REGEX, '') ?? null;
}

export const NON_DIGITS_REGEX = /\D/g;
export const NON_ASCII_REGEX = /[^\x00-\x7F]/g;
